export default { sha: '8ce9e288e1ad5efb9bccf073a9a3286a6543a819', buildNumber: 'undefined' }
